import React from 'react';
import { SPageCard } from './styles';

export const PageCard = ({ children, ...rest }) => {
  return <SPageCard {...rest}>{children}</SPageCard>;
};
